
<div class="input-frame" :class="{ 'is-alert': errorTest }">
	<label class="label" :for="inputId" :data-text="label">
		<span>{{ label }}</span>
	</label>

	<div class="form-group" :class="{ 'is-disabled': disabled }">
		<input
			class="form-group-input"
			:id="inputId"
			ref="input"
			v-model="invoiceNumber"
			:placeholder="placeholder"
			:disabled="disabled"
			:readonly="readonly"
			@input="onInput"
			@blur="onBlur"
			:required="required"
			:pattern="regex"
			maxlength="10"
			minlength="7"
			@paste.prevent
		/>
	</div>

	<div class="msg-alert" v-if="displayError">
		<div class="msg-alert-inner">{{ errorMsg }}</div>
	</div>
</div>

